import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtMXN } from "@/lib/format";

export default function AdminSubscriptions() {
  const [data, setData] = useState({ subscriptions: [], stats: { active: 0, paused: 0, cancelled: 0, mrr: 0 } });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/subscriptions").then((r) => {
      setData(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="p-8" data-testid="admin-subscriptions">
      <h1 className="font-display text-4xl tracking-wider uppercase text-white mb-8">Suscripciones Arre Box</h1>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
        <Stat label="Activas" value={data.stats.active} />
        <Stat label="Pausadas" value={data.stats.paused} />
        <Stat label="Canceladas" value={data.stats.cancelled} />
        <Stat label="MRR" value={fmtMXN(data.stats.mrr)} highlight />
      </div>

      {loading ? (
        <div className="text-white/50">Cargando...</div>
      ) : (
        <div className="bg-arre-surface border border-arre-border overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="border-b border-arre-border">
              <tr className="text-left text-[10px] tracking-[0.25em] uppercase text-white/50">
                <th className="p-4">Cliente</th>
                <th className="p-4">Tier</th>
                <th className="p-4">Precio</th>
                <th className="p-4">Estado</th>
                <th className="p-4">Pago</th>
                <th className="p-4">Próximo</th>
                <th className="p-4">Inicio</th>
              </tr>
            </thead>
            <tbody>
              {data.subscriptions.map((s) => (
                <tr key={s.id} className="border-b border-arre-border last:border-0 text-white" data-testid={`sub-row-${s.id}`}>
                  <td className="p-4">
                    <div className="font-display">{s.user_email}</div>
                  </td>
                  <td className="p-4">{s.tier_name}</td>
                  <td className="p-4 text-arre-red font-bold">{fmtMXN(s.price)}</td>
                  <td className="p-4 uppercase text-xs tracking-widest">{s.status}</td>
                  <td className="p-4 text-xs">{s.payment_status}</td>
                  <td className="p-4 text-xs">{s.next_billing_date ? new Date(s.next_billing_date).toLocaleDateString("es-MX") : "—"}</td>
                  <td className="p-4 text-xs text-white/50">{new Date(s.created_at).toLocaleDateString("es-MX")}</td>
                </tr>
              ))}
              {data.subscriptions.length === 0 && (
                <tr><td colSpan={7} className="p-10 text-center text-white/40">Sin suscripciones todavía.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function Stat({ label, value, highlight }) {
  return (
    <div className={`p-5 border ${highlight ? "border-arre-red bg-arre-red/5" : "border-arre-border bg-arre-surface"}`}>
      <div className="text-[10px] tracking-[0.25em] uppercase text-white/50">{label}</div>
      <div className="font-display text-3xl text-white mt-1">{value}</div>
    </div>
  );
}
